/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext, useRef } from 'react';
import './styles.css';
import { v4 as uuidv4 } from 'uuid';
import AnimatedImage from '../Animations/AnimatedImage';
import { cdnURL } from '../../config';
import S3UploadHook from '../../helpers/UploadToS3';
import CameraComponent from './Capture';
import { dataURLtoFile } from '../../helpers/CommonFunctions';
import { insuranceLanguageContent } from '../../pages/InsuranceDocuments/InsuranceLanguageContent';
import ApplicationContext from '../../context/ApplicationContext';

const CameraCapture = (props) => {
    const { capturedImage, setCapturedImage, filePath, setImageLoading, cameraTitle, id  } = props;
    const { selectedLanguage } = useContext(ApplicationContext);
    const canvasRef = useRef(null);

    const handleCapture = async() => {
        const video = document.querySelector('video');
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
  
        if (video) {
            setImageLoading(true);
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            context.drawImage(video, 0, 0);
            const imageDataURL = canvas.toDataURL('image/jpeg');
            const imageBlob = imageDataURL;
            const fileName = `image-${uuidv4()}.jpeg`;
            var file = dataURLtoFile(imageBlob, fileName);
            const url= await S3UploadHook(file, filePath, false);
            const val =`${filePath}/${file.name}`;
            setCapturedImage(val);
            setImageLoading(false);
        }
    };

    return (
        <div className='relative mt-2'>
            <div className='m-auto flex justify-center'>
                <div className='flex justify-between flex-col gap-[40px] items-center'>
                    <div className="border-[2px] border-[#007EB4] py-[14px] px-[25px] w-[310px] sm:w-[420px] relative">
                        <p className={`text-sm text-[#333] px-[15px] ${(selectedLanguage === 'vi' && id==="id") ? 'left-[4px] sm:left-[55px]' : 'left-[72px] sm:left-[120px]'} absolute -top-[8px]`}>{cameraTitle}</p>
                        {capturedImage === '' ? 
                            // <Camera ref={camera} facingMode="environment" aspectRatio={16 / 9} />
                            // <Camera
                            //     onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }
                            // />
                            <CameraComponent capturedImage={capturedImage} setCapturedImage={setCapturedImage} />
                            : <AnimatedImage url={`https://${cdnURL}/${capturedImage}`} alt={id} />}
                        {/* <Camera
                            onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }
                        /> */}
                        <p className='bg-[#F2F2F2] sm:left-[120px] w-[180px] h-[2px] -bottom-[2px] text-sm text-[#333] px-[15px] left-[60px] absolute' />
                    </div>
                    <button data-testid="capture_photo" onClick={() => capturedImage === '' ? handleCapture() : setCapturedImage('')} className='blue-shadow w-[164px] text-sm text-[#007EB4] font-normal min-h-[91px] h-auto mb-[20px] rounded py-[16px] px-[32px] flex flex-col justify-center items-center'>
                        <img src="/images/Camera.svg" alt="photo" className='mb-2' />
                        {capturedImage === '' ? insuranceLanguageContent['take-photo'][selectedLanguage] : insuranceLanguageContent['re-take-photo'][selectedLanguage]}
                    </button>
                </div>
            </div>
            <canvas ref={canvasRef} style={{ display: 'none' }} />
        </div>
    );
};

export default CameraCapture;
